import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  UsageStatisticsReferenceInputFromJSON
} from '@/api'

export interface UsageStatisticsReference {
  referenceType: SystemCode
  inputs: {
    userType: SystemCode
    counter: number
  }[]
}

export function UsageStatisticsReferenceFromJSON(
  json: any
): UsageStatisticsReference {
  return {
    referenceType: exists(json, 'reference_type')
      ? SystemCodeFromJSON(json.reference_type)
      : defaultSystemCode(),
    inputs: exists(json, 'inputs')
      ? json.inputs.map(UsageStatisticsReferenceInputFromJSON)
      : []
  }
}
